import { Component, OnInit } from "@angular/core";
import { GeneralService } from 'src/app/services/general/general.service';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { environment } from "src/environments/environment";
import { customLocalStorage } from "src/utils/utils";
import { KakaoSyncLocalStorageKey } from "./interfaces/kakao";
import { TokenResponse } from "./interfaces/main";
import { isCabinetLink } from "./services/cabinet/cabinet.service";
import { KakaoService } from "./services/kakao/kakao.service";
import { SignupService } from "./services/signup/signup.service";

@Component({
  template: ''
})
export class KakaoCallbackComponent implements OnInit {

  private readonly loginCallback = 'oauth/kakao/login';
  private readonly friendAgreeCallback = 'oauth/kakao/friend';
  private readonly phoneAgreeCallback = 'oauth/kakao/phone';

  constructor(
    private signupService: SignupService,
    private kakaoService: KakaoService,
    private snackbarService: SnackbarService,
    private generalService: GeneralService,
  ) { }

  ngOnInit(): void {
    this.onKakaoCallback();
  }

  ionViewDidEnter(): void {
  }

  private onKakaoCallback(): void {
    const url: URL = new URL(window.location.href);
    // 콜백 처리
    const code: string | null = url.searchParams.get('code');
    if (code !== null) {
      this.kakaoService.receivedKakaoAuthCodeList.push(code);
    }
    // 전에 있었던 위치(주소)
    const state: string | null = url.searchParams.get('state');
    // 로그인 콜백 처리
    if (url.href.includes(this.loginCallback)) {
      // get token request
      if (code) {
        this.signupService.getTokenUsingKakaoCode(code).subscribe((res: TokenResponse) => {
          customLocalStorage.setItem('jwt', res.data.jwtToken);
          this.initializeApp(state, res.data.isNewUser ? 'signup' : 'signin');
          this.handleTermAgreedState();
        }, error => {
          this.snackbarService.openSnackBar(SnackbarService.LOGIN_FAILED);
          this.initializeApp(); 
        })
      } else {
        this.initializeApp();
      }
      return;
    }

    if (url.href.includes(this.phoneAgreeCallback)) {
      if (code) {
        this.kakaoService.updatePhoneAgreement(code).subscribe((res) => {
          this.kakaoService.phoneNumberAgreeChanged = true;
          this.initializeApp(state)
        })
      }
    }

    // 친구동의 콜백 처리3
    if (url.href.includes(this.friendAgreeCallback)) {
      if (code) {
        this.kakaoService.updateFriendAgreement(code).subscribe((res) => {
          this.initializeApp(state, 'kakaoFriendAgreed');
        })
      } else {
        this.initializeApp(state);
      }
    }
  }

  private initializeApp(state: string | null = null, flag?: 'signin' | 'signup' | 'kakaoFriendAgreed'): void {
    this.generalService.toggleGlobalPageLoading(true);
    const initializeTimeout = setTimeout(() => {
      if (state) {
        const decodedState = decodeURIComponent(state);
        const redirectRegex = /redirect=([^&]+)/;
        const redirectToRegex = /redirect_to=([^&]+)/;
        const redirectMatch = decodedState.match(redirectRegex);
        if (redirectMatch && redirectMatch[1] === 'true') {
          this.signupService.init(undefined, flag, isCabinetLink ? '' : 'gnb/main');
          const redirectToMatch = decodedState.match(redirectToRegex);
          const jwt = customLocalStorage.getItem('jwt');
          if (redirectToMatch !== null) {
            if (redirectToMatch[1] === 'cabinet') {
              location.replace(`${environment.cabinetWebUrl}${jwt ? `?token=${jwt}` : ''}`);
            }
          }
          return;
        }
        this.signupService.init(`${environment.webUrl}${decodedState[0] === '/' ? decodedState : ('/' + decodedState)}`, flag, isCabinetLink ? '' : 'gnb/main');  
      } else {
        this.signupService.init(undefined, flag, isCabinetLink ? '' : 'gnb/main');
      }
      this.generalService.toggleGlobalPageLoading(false);
      clearTimeout(initializeTimeout);
    }, 1000);
  }

  /** 
   * kakao sync한 경우에만 동작하는 함수
   * 성공적으로 sync 완료했다는 snackbar 보이기 (최초 한번만)
   * only for web
   */
   private handleTermAgreedState(): void {
    if (!this.generalService.isApp) {
      const kakaoSyncStarted = customLocalStorage.getItem(KakaoSyncLocalStorageKey);
      if (kakaoSyncStarted !== null) {
        this.snackbarService.openSnackBar(SnackbarService.AFTER_KAKAO_SYNC);
        customLocalStorage.removeItem(KakaoSyncLocalStorageKey);
      }
    }
  }
}